











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import constants      from '@/constants';
import { SearchType } from '@/models/SearchType';
import { BButton, BCollapse } from 'bootstrap-vue';
import { Route } from 'vue-router';
import { VIcon } from 'vuetify/lib';

@Component({
  name: 'SearchResults'
})

export default class SearchResults extends Vue {

  //
  // data properties
  //
  // ... expose route names from constants for router-links
  miniDetailRouteName   = constants.RouteNames.MiniDetail;
  mainRouteName         = constants.RouteNames.Main;

  //
  // computed properties
  //

  get searchResults() {
    return this.$store.state.searchResults.currentSearch.siteRefs;
  }


  get activeSearchResult() {
    return this.$store.state.searchResults.currentSearch;
  }

  get searchTerms() {
    const terms = this.$store.state.searchResults.currentSearch.searchTerms;
    const quotedTerms = terms.map((term: string) => `"${term}"`)
    return quotedTerms.join(", ");
  }

  get searchResultsByState() {

    const statesToSites: Record<string, any> = {};

    this.$store.state.searchResults.currentSearch.siteRefs.forEach((site: any) => {
      const state = site.state;
      const sitesInState = statesToSites[state];
      if (sitesInState) {
        sitesInState.push(site);
      } else {
        statesToSites[state] = [site];
      }
    });

    const results = constants.StatesAndTerritories.map((state: Record<string, string>) => {
      return {
        ...state,
        results: statesToSites[state.key] || []
      }
    }).filter((state: Record<string, any>) => state.results.length > 0);


    return results;
  }

  get currentRoute() {
    return this.$router.currentRoute;
  }

  get searchResultsStatusText() {
    const numResults = this.activeSearchResult.siteRefs.length;

    return (this.activeSearchResult.searchType === SearchType.Keyword) ?

      // Keyword search
      `Showing ${numResults} USGS ${numResults === 1 ? "station matches" : "stations for"}  "${this.activeSearchResult.searchTerms.join(' ')}"` :

      // Map search (near my location only)
      `Showing ${numResults} USGS stations near ${this.activeSearchResult.searchTerms.join(" ")}`;
  }

}

